import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { RichTextTile } from 'components/no-auth/common/RichTextTile/RichTextTile';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import LoneButtonSection from 'components/no-auth/common/sections/LoneButtonSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import Cookies from 'universal-cookie';

import FaqSection from '../components/no-auth/common/sections/FaqSection';

const BonusPage = (props) => {
    const location = useLocation();

    useEffect(() => {
        const cookies = new Cookies();
        let pathname = location.pathname;
        let arr = pathname.split('/');
        let inviteCode = arr.pop();
        if (arr.includes('referral') && inviteCode) {
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            cookies.set('invite_code', inviteCode, { path: '/', expires: expirationDate });
        }
    }, []);

    return (
        <>
            {props.heroTitle && <HeroSection title={props.heroTitle} data={props.heroData} btnVariant="primary" noIconBtn />}
            <ColoredSectionContainer dimension="average">
                {props.content && <RichTextTile text={props.content} />}
                {props.termsLink && <LoneButtonSection btn={props.termsLink} variant="tertiary" desktopAlignLeft />}
            </ColoredSectionContainer>
            {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding />}
        </>
    );
};

BonusPage.propTypes = {
    heroTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    heroData: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    termsLink: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
    faqTitle: PropTypes.string,
    questions: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroData: state.extra?.strapiApi?.hero_block,
        content: state.extra?.strapiApi?.bonus_content,
        termsLink: state.extra?.strapiApi?.terms_link,
        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(BonusPage));
